import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ProductOnDocumentWithReverseChargeCommunityTransactionWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.sale.validation.items.name.product-on-document-with-reverse-charge-community-transaction-warning');
    }
}
